export const manifest = {
  screens: {
    scr_8srzok: { name: "仪表盘", route: "/", position: {"x":160,"y":7760} },
    scr_2peiil: { name: "对话", route: "/chat", position: {"x":1560,"y":7760} },
    scr_d1htc8: { name: "模型中心", route: "/models", position: {"x":160,"y":1820} },
    scr_vlxm0i: { name: "Skills 中心", route: "/skills", position: {"x":1560,"y":1820} },
    scr_0gw9sh: { name: "知识库中心", route: "/knowledge-bases", position: {"x":2960,"y":1820} },
    scr_z28fwa: { name: "Agent 中心", route: "/agents", position: {"x":4360,"y":1820} },
    scr_jjv0g7: { name: "创建 Agent", route: "/agents/new", position: {"x":160,"y":3800} },
    scr_1o6kf4: { name: "任务面板", route: "/tasks", position: {"x":160,"y":5780} },
    scr_zxc9ct: { name: "历史会话", route: "/history-sessions", position: {"x":1560,"y":5780} },
    scr_zobpeu: { name: "历史记录", route: "/history", position: {"x":2960,"y":5780} },
    scr_88nget: { name: "系统设置", route: "/settings", position: {"x":0,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_jrthmp: { name: "Resource Centers", x: 0, y: 1600, width: 5720, height: 1180 },
    sec_4zv7i3: { name: "Agent Creation", x: 0, y: 3580, width: 1520, height: 1180 },
    sec_23qjsv: { name: "Activity & Tasks", x: 0, y: 5560, width: 4320, height: 1180 },
    sec_0evxib: { name: "Main Navigation", x: 0, y: 7540, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_jrthmp", children: [
      { kind: "screen", id: "scr_d1htc8" },
      { kind: "screen", id: "scr_vlxm0i" },
      { kind: "screen", id: "scr_0gw9sh" },
      { kind: "screen", id: "scr_z28fwa" },
    ] },
    { kind: "section", id: "sec_4zv7i3", children: [
      { kind: "screen", id: "scr_jjv0g7" },
    ] },
    { kind: "section", id: "sec_23qjsv", children: [
      { kind: "screen", id: "scr_1o6kf4" },
      { kind: "screen", id: "scr_zxc9ct" },
      { kind: "screen", id: "scr_zobpeu" },
    ] },
    { kind: "section", id: "sec_0evxib", children: [
      { kind: "screen", id: "scr_8srzok" },
      { kind: "screen", id: "scr_2peiil" },
    ] },
    { kind: "screen", id: "scr_88nget" },
  ],
}
